"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _UIUnstyledButton = _interopRequireDefault(require("UIComponents/button/UIUnstyledButton"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var createPluginButton = function createPluginButton(_ref) {
  var icon = _ref.icon,
      toolTip = _ref.toolTip,
      _ref$tooltipPlacement = _ref.tooltipPlacement,
      tooltipPlacement = _ref$tooltipPlacement === void 0 ? 'bottom' : _ref$tooltipPlacement;

  var PluginButton = function PluginButton(_ref2) {
    var onClick = _ref2.onClick;
    return _react.default.createElement(_UITooltip.default, {
      title: toolTip,
      placement: tooltipPlacement
    }, _react.default.createElement(_UIUnstyledButton.default, {
      onClick: onClick
    }, _react.default.createElement(_UIIcon.default, {
      name: icon
    })));
  };

  PluginButton.propTypes = {
    onClick: _react.PropTypes.func.isRequired
  };
  return PluginButton;
};

var _default = createPluginButton;
exports.default = _default;
module.exports = exports.default;